import { render, staticRenderFns } from "./EmployeeRecruitment.vue?vue&type=template&id=4ed6601e&scoped=true"
import script from "./EmployeeRecruitment.vue?vue&type=script&lang=js"
export * from "./EmployeeRecruitment.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRecruitment.vue?vue&type=style&index=0&id=4ed6601e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6601e",
  null
  
)

export default component.exports